<p>
  link-callback works!
</p>
